import { selectLoggedinUserName } from 'accessors'
import useLogzIo from 'hooks/useLogzIo'
import { useEffect } from 'react'
import { useSelector } from 'react-redux'

const NotAuthed = () => {
  const { userNotAuthorized } = useSelector(s => s.login)

  const uiUserName = useSelector(selectLoggedinUserName)

  const log = useLogzIo()

  useEffect(
    () => {
      if (userNotAuthorized) {
        log({
          level: 'Info',
          message: `User ${uiUserName} got 400-UnAuthorized on ${document.location.pathname}`
        })
      }
    },
    [uiUserName, log, userNotAuthorized],
    []
  )

  return (
    <>
      {userNotAuthorized ? (
        <div className="unauthorized-notification">
          <h1>You don't have permissions to access this page.</h1>
          <p>Please contact your administrator</p>
        </div>
      ) : null}
    </>
  )
}

export default NotAuthed
